import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import { PropsWithChildren } from 'react';

export const PanelFieldSection = ({
    title,
    children,
    isFocused = false,
    labelStyle = null
}: PropsWithChildren<{
    title: string | JSX.Element;
    isFocused?: boolean;
    labelStyle?: any;
}>) => {
    const theme = useTheme();

    return (
        <Grid item xs={12}>
            <Typography
                style={
                    labelStyle ?? {
                        paddingTop: 18,
                        paddingLeft: 25,
                        fontWeight: 600,
                        fontSize: '13px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        color: isFocused ? theme.palette.secondary[800] : '#616161'
                    }
                }
            >
                {title}
            </Typography>
            <Grid>{children}</Grid>
        </Grid>
    );
};
